"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.initPolkadotSnap = void 0;
const index_1 = require("../index");
const utils_1 = require("../utils");
function transformAccounts(accounts) {
    return accounts.map((address, i) => ({
        address,
        name: `Polkadot Snap #${i}`,
        type: 'ethereum'
    }));
}
function injectPolkadotSnap({ win, injectedSnapId = 'metamask-polkadot-snap', config, snapOrigin, snapInstallationParams }) {
    win.injectedWeb3[injectedSnapId] = {
        enable: () => __awaiter(this, void 0, void 0, function* () {
            const snap = (yield (0, index_1.enablePolkadotSnap)(config, snapOrigin, snapInstallationParams)).getMetamaskSnapApi();
            return {
                accounts: {
                    get: () => __awaiter(this, void 0, void 0, function* () {
                        const response = yield snap.getAddress();
                        return transformAccounts([response]);
                    }),
                    // Currently there is only available only one account, in that case this method will never return anything
                    // eslint-disable-next-line @typescript-eslint/no-unused-vars
                    subscribe: (_cb) => {
                        return () => { };
                    }
                },
                signer: {
                    signPayload: (payload) => __awaiter(this, void 0, void 0, function* () {
                        const signature = (yield snap.signPayloadJSON(payload));
                        return { id: 0, signature };
                    }),
                    signRaw: (raw) => __awaiter(this, void 0, void 0, function* () {
                        const signature = (yield snap.signPayloadRaw(raw));
                        return { id: 0, signature };
                    })
                }
            };
        }),
        version: '0'
    };
}
/**
 * @param injectedSnapId - Optional ID of injected snap, default: "metamask-polkadot-snap"
 */
function initPolkadotSnap({ config, snapOrigin, snapInstallationParams }, injectedSnapId) {
    return new Promise((resolve) => {
        const win = window;
        win.injectedWeb3 = win.injectedWeb3 || {};
        if ((0, utils_1.hasMetaMask)())
            void (0, utils_1.isMetamaskSnapsSupported)().then((result) => {
                if (result) {
                    injectPolkadotSnap({ win, injectedSnapId, config, snapOrigin, snapInstallationParams });
                    resolve(true);
                }
                else {
                    resolve(false);
                }
            });
        else
            resolve(false);
    });
}
exports.initPolkadotSnap = initPolkadotSnap;
//# sourceMappingURL=data:application/json;base64,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